import { Navigate, Route, Routes } from 'react-router-dom';
import HelpdeskDashboardPage from './HelpdeskDashboardPage';
import TicketsPage from './TicketsPage';
import KnowledgeBasePage from './KnowledgeBasePage';
import ReportsPage from './ReportsPage';

export default function HelpdeskRoutes() {
  return (
    <Routes>
      <Route index element={<HelpdeskDashboardPage />} />
      <Route path="tickets" element={<TicketsPage />} />
      <Route path="knowledge" element={<KnowledgeBasePage />} />
      <Route path="reports" element={<ReportsPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
